<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                    Col
                        h2 {{ $t('certsmanage.pageTitleText') }}
                    Col
                        ExplainBtn(:objectExplanation="objectsExplanation")
            p Upload and download your own cert.

        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :userCanExport="$store.getters.isAdmin"
            :actionInTable="true"
            :userCanBatchEdit="false"
            :drawerTitleKey="drawerTitleKey"
            :sort="sort"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="keypairname"
            :primarySearchKeyI18="$t('certsmanage.keypairname')"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','CertsUpload')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','CertsUpload')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','CertsUpload')"
        )
</template>
<script>
import Vue from "vue";
Vue.component("TagList", TagList);
Vue.component("DownloadCertBtn", DownloadCertBtn);

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import DownloadCertBtn from "@/components/DownloadCertBtn";
import bus from "@/libs/bus.js";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);

import { settingZoneExplain, keypairname, action } from "./fields.js";

export default {
    name: "CertsManage",
    components: { RcmTable, TagList, DownloadCertBtn },
    data() {
        return {
            esIndex: "rcm-certpems",
            drawerTitleKey: "keypairname",
            sort: [{ modifiedDate: { order: "desc" } }],
            objectsExplanation: {},
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("certsmanage.createText");
        },
        sectionInfo() {
            return [];
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: action(this),
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      createBy: {},
                      keypairname: keypairname(this),
                      _id: {},
                      certpemUpload: {},
                      certkeyUpload: {},
                      commonName: {},
                      issuerCommonName: {},
                      sanDns: {},
                      sanIp: {},
                      validityStart: {},
                      validityEnd: {},
                      expiredDays: {},
                      emailAddress: {},
                      createdDate: {},
                      modifiedDate: {},
                      certpemRaw: {},
                      certkeyRaw: {},
                      certRaw: {},
                      certUsedBy: {},
                      certUsedByEdge: {},
                      certUsedByGroup: {},
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: action(this),
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      createBy: {},
                      keypairname: keypairname(this),
                      _id: {},
                      certpemUpload: {},
                      certkeyUpload: {},
                      commonName: {},
                      issuerCommonName: {},
                      sanDns: {},
                      sanIp: {},
                      validityStart: {},
                      validityEnd: {},
                      expiredDays: {},
                      emailAddress: {},
                      createdDate: {},
                      modifiedDate: {},
                      certpemRaw: {},
                      certkeyRaw: {},
                      certRaw: {},
                      certUsedBy: {},
                      certUsedByEdge: {},
                      certUsedByGroup: {},
                      status: {},
                  };
        },
    },
    methods: {},
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/CertsManage/Page.vue